import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { AuthRoutingModule } from './auth.routing';
import { LoginComponent } from './login/login.component';
import { OptinRemindComponent } from './optin-remind/optin-remind.component';
import { SignupComponent } from './signup/signup.component';
import { KazaComponent } from './kaza/kaza.component';
import { TagsComponent } from './tags/tags.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectTypesResolver } from '../../shared/resolvers/project-types-resolver';
import { CountriesResolver } from '../../shared/resolvers/countries-resolver';
import { ProfessionalJobService, ProfessionalService, TokenCookieStorage } from '@adeo/ngx-kozikaza-api';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { FormCheckboxService } from '../../shared/services/utilities/form-checkbox.service';
import { UtilsModule } from '../../utils/utils.module';
import { SlugifyPipe } from '../../utils/pipes/slugify.pipe';
import { KzTooltipModule } from '../../kz-ui/ui/tooltip/kz-tooltip.module';
import { KzButtonModule } from '../../kz-ui/ui/form/button/kz-button.module';
import { KzLoaderModule } from '../../kz-ui/ui/loader/kz-loader.module';
import { AuthSharedModule } from './auth-shared.module';
import { SigninFormLiteModule } from './components/signin-form-lite/signin-form-lite.module';
import { KzFormModule } from '../../kz-ui/ui/form/kz-form.module';
import { AuthComponent } from './auth.component';
import { KzModalModule } from '../../kz-ui/ui/modal/kz-modal.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { KzIconsModule } from '../../kz-ui/ui/icon/kz-icons.module';
import { KzBadgeModule } from '../../kz-ui/ui/badge/kz-badge.module';
import { CountryLegacyApiModule } from '@adeo/ngx-kozikaza-api/misc/country-legacy';
import { EmailCheckComponent } from "./email-check/email-check.component";
import { RouterModule } from "@angular/router";
import { KzJumbotronModule } from "../../kz-ui/ui/jumbotron/kz-jumbotron.module";
import { ConstructionDateComponent } from './construction-date/construction-date.component';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    SignupComponent,
    KazaComponent,
    TagsComponent,
    ForgotPasswordComponent,
    ConstructionDateComponent,
  ],
  imports: [
    RouterModule,
    CountryLegacyApiModule,
    AuthSharedModule,
    AuthRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UtilsModule,
    SharedModule,
    KzTooltipModule,
    KzButtonModule,
    KzLoaderModule,
    SigninFormLiteModule,
    KzFormModule,
    KzIconsModule,
    KzModalModule,
    NgSelectModule,
    KzBadgeModule,
    EmailCheckComponent,
    KzJumbotronModule,
    OptinRemindComponent,
  ],
  providers: [
    ProjectTypesResolver,
    CountriesResolver,
    TokenCookieStorage,
    FormCheckboxService,
    SlugifyPipe,
    ProfessionalJobService,
    ProfessionalService
  ]
})
export class AuthModule {}
